import { Box, InputBase, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
export interface StyledWrapperProps {
  $hasError?: boolean;
  $isFilled?: boolean;
}

const FONT_FAMILY = '"Rookery_New", sans-serif';

export const InputWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$hasError' && prop !== '$isFilled',
})<StyledWrapperProps>(({ $hasError }) => ({
  backgroundColor: '#fefcfa',
  height: '4rem',
  borderRadius: '1rem',
  border: '0.0625rem solid',
  padding: '0.5rem 1rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '2px',
  position: 'relative',
  transition: 'all 200ms ease',

  borderColor: $hasError ? '#ef4444' : '#adaba9',

  '&:focus-within': {
    borderColor: $hasError ? '#ef4444' : '#0e77da',
  },
}));

export const TinyLabel = styled(Typography)({
  fontFamily: FONT_FAMILY,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#5f5e60',
  animation: 'fadeIn 0.2s ease-in',
});

export const StyledInput = styled(InputBase)({
  width: '100%',
  '& .MuiInputBase-input': {
    padding: 0,
    backgroundColor: 'transparent',
    fontFamily: FONT_FAMILY,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0.0313rem',
    color: '#161c27',
    '&::placeholder': {
      color: '#5f5e60',
      opacity: 1,
    },
    '&:focus': {
      outline: 'none',
    },
  },
});

export const ErrorContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.375rem',
  color: '#dc2626',
  paddingTop: '0.5rem',
});

export const ErrorMessage = styled('div')({
  color: '#dc2626',
});
